/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_Mockups_Desc7Inputs */

const en_svc_ai_image_pod_automation_mockups_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Designs on tees, mugs and posters with color variants, rendered automatically. Same pipeline also does product photos and ad creatives for brands.`)
};

const ar_svc_ai_image_pod_automation_mockups_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصاميم على قمصان وأكواب وملصقات مع متغيرات لونية، تُنشأ تلقائيا. نفس الخط ينتج أيضا صور منتجات وإعلانات للعلامات.`)
};

const bn_svc_ai_image_pod_automation_mockups_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টি, মগ আর পোস্টারে রঙের ধরনসহ ডিজাইন, স্বয়ংক্রিয়ভাবে রেন্ডার। একই পাইপলাইন ব্র্যান্ডের প্রোডাক্ট ছবি আর বিজ্ঞাপন ক্রিয়েটিভও করে।`)
};

const de_svc_ai_image_pod_automation_mockups_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Designs auf Shirts, Tassen und Postern mit Farbvarianten, automatisch gerendert. Dieselbe Pipeline erstellt auch Produktfotos und Werbekreationen für Marken.`)
};

const es_svc_ai_image_pod_automation_mockups_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diseños en camisetas, tazas y pósteres con variantes de color, renderizados automáticamente. El mismo pipeline también hace fotos de producto y creatividades para marcas.`)
};

const fr_svc_ai_image_pod_automation_mockups_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Designs sur t-shirts, mugs et posters avec variantes de couleur, rendus automatiquement. Le même pipeline produit aussi photos produit et visuels publicitaires pour les marques.`)
};

const pt_svc_ai_image_pod_automation_mockups_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Designs em t-shirts, canecas e pósteres com variantes de cor, gerados automaticamente. O mesmo pipeline também faz fotos de produto e criativos para marcas.`)
};

const zh_svc_ai_image_pod_automation_mockups_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T 恤、马克杯和海报的效果图带配色变体，自动渲染。同一条管道也给品牌做产品图和广告创意。`)
};

const tr_svc_ai_image_pod_automation_mockups_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tişört, kupa ve posterlerde renk varyantlı tasarımlar, otomatik renderlanır. Aynı hat markalara ürün foto ve reklam kreatifleri de üretir.`)
};

const ru_svc_ai_image_pod_automation_mockups_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дизайны на футболках, кружках и постерах с цветовыми вариантами рендерятся автоматически. Тот же пайплайн делает брендам фото товаров и рекламные креативы.`)
};

const pl_svc_ai_image_pod_automation_mockups_desc7 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Mockups_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekty na koszulkach, kubkach i plakatach z wariantami kolorów, renderowane automatycznie. Ten sam potok robi markom też zdjęcia produktowe i kreacje reklamowe.`)
};

/**
* | output |
* | --- |
* | "Designs on tees, mugs and posters with color variants, rendered automatically. Same pipeline also does product photos and ad creatives for brands." |
*
* @param {Svc_Ai_Image_Pod_Automation_Mockups_Desc7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_mockups_desc7 = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_Mockups_Desc7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_Mockups_Desc7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_mockups_desc7(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_mockups_desc7(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_mockups_desc7(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_mockups_desc7(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_mockups_desc7(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_mockups_desc7(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_mockups_desc7(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_mockups_desc7(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_mockups_desc7(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_mockups_desc7(inputs)
	return en_svc_ai_image_pod_automation_mockups_desc7(inputs)
});
export { svc_ai_image_pod_automation_mockups_desc7 as "svc_ai-image-pod-automation_MOCKUPS_desc" }